import styled from "styled-components";
import Button from "../../../../kanopy-ui/Button";

export const LogoutButtonStyled = styled(Button)`
   right: 162px;
   margin-top: 66px;
   position: absolute;
   font-size: 14px;
`;
